import { render, staticRenderFns } from "./CurrencyAmountInput.vue?vue&type=template&id=90a052a2&scoped=true"
import script from "./CurrencyAmountInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrencyAmountInput.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CurrencyAmountInput.vue?vue&type=style&index=0&id=90a052a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a052a2",
  null
  
)

export default component.exports